/**
 * Multipart upload, outside the JSON client: the browser sets the boundary
 * itself. Same headers and error handling as the JSON client.
 */
import { getToken } from '@/features/auth/session';
import { request } from './client';

export const uploadFile = async (path: string, file: File): Promise<void> => {
  const formData = new FormData();
  formData.append('file', file);
  const headers = new Headers();
  const token = getToken();
  if (token) headers.set('Authorization', token);
  const response = await fetch(`/api/${path}`, {
    method: 'POST',
    headers,
    body: formData,
    credentials: 'same-origin',
  });
  if (!response.ok)
    throw new Error(`Upload failed with status ${response.status}`);
};

export const deleteFile = (path: string) => request(path, { method: 'DELETE' });
